var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.$style.headerGrid, {'narrow-lhs': _vm.narrowLhs}]},_vm._l((_vm.block.innerBlocks),function(innerBlock,key){return _c('Block',_vm._b({key:`headerBlock${key}`,attrs:{"block":innerBlock,"block-id":_vm.blockId,"lazy":false}},'Block',{ id: 'header-block' + '-' + key, class: 'header-block' },false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }